import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import reportWebVitals from "./reportWebVitals";
import Router from "./route/Router";
import { createStore } from "polotno/model/store";
import { ThumbnailProvider } from "./contexts/ThumbnailContext";
import { dimensions } from "./utils/helper";
import store from "./store";
import DeviceSizeWarning from "./components/DeviceSizeWarning";
import Clarity from "@microsoft/clarity";

const polotStore = createStore({
  key: "gj22OYPNEiZGOv4RvhGx",
  showCredit: false,
});
const dpi = 72;
polotStore.selectPage("master");
polotStore.setUnit({
  unit: "in",
  dpi: dpi,
});
polotStore.toggleRulers();

Clarity.init('vqf0nfwvad')

const exportStore = createStore({
  key: "gj22OYPNEiZGOv4RvhGx", // you can create it here: https://polotno.com/cabinet/
  // you can hide back-link on a paid license
  // but it will be good if you can keep it for Polotno project support
  showCredit: false,
});
exportStore.setUnit({
  unit: "in",
});
exportStore.toggleRulers();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
   <DeviceSizeWarning /> 
  <ThumbnailProvider>
    <Provider store={store}>
      <Router store={polotStore} exportStore={exportStore} />
    </Provider>
    </ThumbnailProvider>
  </>
);
reportWebVitals();
